export enum FeatureFlagNames {
  EVENT_REMINDER = 'event-reminder',
}
